import { parser as o } from "./ghl-ui.es431.js";
import { LRLanguage as a, indentNodeProp as s, continuedIndent as r, foldNodeProp as i, foldInside as c, LanguageSupport as d } from "./ghl-ui.es424.js";
const f = () => (n) => {
  try {
    JSON.parse(n.state.doc.toString());
  } catch (e) {
    if (!(e instanceof SyntaxError))
      throw e;
    const t = g(e, n.state.doc);
    return [{
      from: t,
      message: e.message,
      severity: "error",
      to: t
    }];
  }
  return [];
};
function g(n, e) {
  let t;
  return (t = n.message.match(/at position (\d+)/)) ? Math.min(+t[1], e.length) : (t = n.message.match(/at line (\d+) column (\d+)/)) ? Math.min(e.line(+t[1]).from + +t[2] - 1, e.length) : 0;
}
const m = /* @__PURE__ */ a.define({
  name: "json",
  parser: /* @__PURE__ */ o.configure({
    props: [
      /* @__PURE__ */ s.add({
        Object: /* @__PURE__ */ r({ except: /^\s*\}/ }),
        Array: /* @__PURE__ */ r({ except: /^\s*\]/ })
      }),
      /* @__PURE__ */ i.add({
        "Object Array": c
      })
    ]
  }),
  languageData: {
    closeBrackets: { brackets: ["[", "{", '"'] },
    indentOnInput: /^\s*[\}\]]$/
  }
});
function l() {
  return new d(m);
}
export {
  l as json,
  m as jsonLanguage,
  f as jsonParseLinter
};
